import { render } from "./Perseguido.vue?vue&type=template&id=6fa2a7ce"
import script from "./Perseguido.vue?vue&type=script&lang=js"
export * from "./Perseguido.vue?vue&type=script&lang=js"

import "./Perseguido.vue?vue&type=style&index=0&id=6fa2a7ce&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__